<template>
     <div class="wrapper">
		 <div class="wrapper1">
		 <div style="position: relative;">
		 <div class="menu-item-let">
			 <div style="display: flex;flex-direction: column;margin-top: 50px;">
				 <div style="display: flex;">
			  <h1 class="textstyle">
				  <span @click="tohome">
					  Home
				  </span>
				  <!-- <router-link to="home" style="color:#FFE3AC;">Home</router-link> -->
				</h1>
			  <h1 class="textstyle">
				  <span @click="tous">
				  About Us
				  </span>
				 <!-- <router-link to="introduction" style="color:#FFE3AC;">About Us</router-link> -->
				  </h1>
			  <h1 class="textstyle">
				  <span @click="toid">
				  Industrial Disribution
				  </span>
				 <!--  <router-link to="cotton" style="color:#FFE3AC;">Industrial Disribution</router-link> -->
				   </h1>
				</h1>
			  </div>
			   <el-divider></el-divider>
			  </div>
			  <div >
			  <img src="../assets/img/zhonghao.png" alt="" width="150px" height="200px"/>
			  </div>
			  <div style="display: flex;flex-direction: column;margin-top: 50px;">
			  				 <div style="display: flex;">
			  <h1 class="textstyle">
				  <span @click="toPartners">
				  Partners
				  </span>
				  <!-- <router-link to="partners" style="color:#FFE3AC;">Partners</router-link> -->
				   </h1>
				  </h1>
			   <h1 class="textstyle">
				   <span @click="toGB">
				   Giving Back
				   </span>
				    <!-- <router-link to="givingback" style="color:#FFE3AC;">Giving Back</router-link> -->
					</h1>
				  </h1>
			   <h1 class="textstyle">
				   <span @click="toCU">
				   Contact Us
				   </span>
				   <!-- <router-link to="contact" style="color:#FFE3AC;">Contact Us</router-link> -->
					</h1>
				   </h1>
			   </div>
			     <el-divider></el-divider>
			    </div>
		 </div>
	
		  </div>
		 
		 
		 
		 <div style="text-align: center;margin-bottom: 20px;">
		     <h3 ><a style="color: white;" href="https://beian.miit.gov.cn/">沪ICP备2022022427号</a></h3>
		  </div>
		  </div>
		  
		  
		 <div class="appfooter">
		 		 	<img src="../assets/img/home/home-footer.png" alt="" width="100%" height="100%" />
		 </div>
	 </div>  
	 
	
	 
	 
</template>
<script>
export default {
  name: "nav-footer",
  data() {
  	return {
		
	}},
  
  methods:{
	  tohome(){
		  this.$router.push({name:'home'})
	  },
	  tous(){
	  		  this.$router.push({name:'introduction'})
	  },
	  toid(){
	  		  this.$router.push({name:'cotton'})
	  },
	  toPartners(){
	  		  this.$router.push({name:'partners'})
	  },
	  toGB(){
	  		  this.$router.push({name:'givingback'})
	  },
	  toCU(){
	  		  this.$router.push({name:'contact'})
	  }
  }
};
</script>

<style lang="scss" scoped>

 //电脑端
 //最小屏幕宽度，大于1100px
 @media screen and (min-width: 1100px) {
	.wrapper {
		width: 100%;
		background-color: #000000;
		padding: 30px 0;
	}
	.menu-item-let{
		 
		display: flex;
		justify-content: space-around;
		  color: #FFE3AC;
		  font-size: 18px;
		  font-weight: bold;
	}
	.textstyle{
		 padding: 0px 20px;
		 cursor:pointer;
	} 
	.appfooter{
		display: none;
	}
 }
 
 //手机端
 @media screen and (max-width: 1100px) {
	.wrapper1 {
	display: none;
	}
	
 }
</style>
